import { Injectable } from "@angular/core";
import { ApiBrowseAction } from "../../api-actions";
import { ApiSessionService } from "../../api-session.service";
import { ApiStateStoreService } from "../../api-state-store.service";
import { accountId } from "../../apiParams/account-id";
import { sessionId } from "../../apiParams/session-id";
import {
  ApiPrepaidTransaction,
  PrepaidTransaction,
  ApiPrepaidTransactionToPrepaidTransaction as clean
} from "./prepaid-transaction";
import { extractData, OnsipApiResponse } from "../../apiResponse/response-body-new";
import { getApiActionName } from "../../onsip-api-action-new";
import { arrayToRecord } from "../../util/arrayToRecord";
import { ApiResourceService } from "../api-resource.service";
import { ApiPromiseState, ApiPromiseStateService } from "../../api-promise-state.service";
export { PrepaidTransaction };

type PrepaidTransactionBrowseParams =
  | { startDateTime: string; endDateTime: string; limit?: number }
  | { startDateTime?: string; endDateTime?: string; limit: number };

const debug = false;

@Injectable({ providedIn: "root" })
export class PrepaidTransactionService extends ApiResourceService<PrepaidTransaction> {
  constructor(
    session: ApiSessionService,
    store: ApiStateStoreService,
    promiseState: ApiPromiseStateService
  ) {
    super(session, store, promiseState, "PrepaidTransaction", "prepaidTransactionId");
    debug && this.state.subscribe(state => console.warn("PrepaidTransaction", state));
  }

  /**
   * @param StartDateTime string of date in format YYYY-MM-DD. This is the safest date format for the api
   * @param EndDateTime same as StartDateTime
   * @param Limit number of invoices to be fetched. do not need limit if start and end dates are provided
   */
  prepaidTransactionBrowse(
    params: PrepaidTransactionBrowseParams
  ): ApiPromiseState<PrepaidTransaction> {
    this.dispatcher.next({
      parameters: {
        Action: ApiBrowseAction.PrepaidTransactionBrowse,
        AccountId: this.store.state.pipe(accountId()),
        SessionId: this.store.state.pipe(sessionId()),
        StartDateTime: params.startDateTime,
        EndDateTime: params.endDateTime,
        Limit: params.limit
      }
    });
    return this.promiseState.toPromise(ApiBrowseAction.PrepaidTransactionBrowse);
  }

  reducer(response: OnsipApiResponse): void {
    const action = getApiActionName(response);
    switch (action) {
      case ApiBrowseAction.PrepaidTransactionBrowse:
        this.store.mergeStateUpdate(
          this.resourceName,
          arrayToRecord(
            extractData<Array<ApiPrepaidTransaction>>(
              response,
              action,
              "PrepaidTransaction",
              "PrepaidTransactions"
            ).map(clean),
            this.indexKeyName
          ),
          action
        );
        break;
    }
  }
}
